import React, { useState } from "react";
import { IWhatsNewMedia } from "api/whatsNew/whatsNew.type";
import { cardStillUrl } from "utils/previewUrl";

const MEDIA_CLASS = "aspect-[4/3] w-full rounded-lg object-cover bg-black-200";

// Card media shared by the What's New panel and the See-all page. Videos stay preload="metadata" and
// play on hover (the parent card drives that). A GIF renders as its first frame (cardStillUrl, REF-6739);
// FeatureTourModal keeps the original url, so the animation plays once the item is opened. If the
// resize edge fails, fall back to the original url once — keyed by the still url it was given, so a
// different item's media never inherits the fallback.
// `className` replaces the card's own framing (the agent home's tiles fill their box with it).
const WhatsNewCardMedia = ({ media, className = MEDIA_CLASS }: { media: IWhatsNewMedia | null; className?: string }) => {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);

  if (!media) return null;

  if (media.type === "video") return <video src={media.url} className={className} muted loop playsInline preload="metadata" />;

  const still = cardStillUrl(media.url) ?? media.url;
  const src = failedSrc === still ? media.url : still;

  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      decoding="async"
      className={className}
      onError={() => {
        if (src !== media.url) setFailedSrc(still);
      }}
    />
  );
};

export default WhatsNewCardMedia;
